module.exports = __webpack_public_path__ + "static/redime-tus-puntos-1-AR-c0f5beedc6bc07881fb6d0f6f709c661.webp";